<template>
  <!-- https://getbootstrap.com/docs/4.0/utilities/position/ -->
  <div class="pl-4 pt-4 sticky-top" style="height: 100vh;" :class="{
                myrundash: !team || team == 'myrundash' || team == 'Demo',
                MDI: team == 'MDI' || ($router.history.current.path =='/marathondynamics'),
                Ryerson: team == 'Ryerson',
                JKR: team == 'JKR',
              }">
    <!-- Make the top level MyRunDash redirect to the team's home page -->
    <h1 v-if="!team || team == 'myrundash' || team == 'Demo'" @click="setActiveTab('')"><router-link to="/" class="medium-shrink">MyRunDash</router-link></h1>
    <h1 v-if="team == 'MDI'" @click="setActiveTab('')"><router-link :to="{ name: 'MDI Home' }" class="medium-shrink">MyRunDash</router-link></h1>
    <h1 v-if="team == 'Ryerson'" @click="setActiveTab('')"><router-link to="/" class="medium-shrink">MyRunDash</router-link></h1>
    <h1 v-if="team == 'JKR'" @click="setActiveTab('')"><router-link :to="{ name: 'JKR Home' }" class="medium-shrink">MyRunDash</router-link></h1>
    <hr>
    <div>
      <div v-if="auth && isCoach" :class="{ 'active-tab': activetab == 'coachdashboard' }" class="tab-div">
        <router-link to="/coachdashboard" class="sidebar-link"><h3 @click="setActiveTab('coachdashboard')">Coach's Dashboard</h3></router-link>
      </div>
      <div v-if="auth" :class="{ 'active-tab': activetab == 'dashboard' }" class="tab-div">
        <router-link to="/dashboard" class="sidebar-link"><h3 @click="setActiveTab('dashboard')">Dashboard</h3></router-link>
      </div>
      <div v-if="auth" :class="{ 'active-tab': activetab == 'userprofile' }" class="tab-div">
        <router-link to="/profile" class="sidebar-link"><h3 v-if="auth" @click="setActiveTab('userprofile')">My Profile</h3></router-link>
      </div>
      <div v-if="auth" :class="{ 'active-tab': activetab == 'training' }" class="tab-div">
        <router-link to="/trainingplan" class="sidebar-link"><h3 v-if="auth" @click="setActiveTab('training')">Training Plan & Log</h3></router-link>
      </div>
      <div v-if="auth" :class="{ 'active-tab': activetab == 'racelog' }" class="tab-div">
        <router-link to="/racelog" class="sidebar-link"><h3 v-if="auth" @click="setActiveTab('racelog')">Past Races</h3></router-link>
      </div>
      <div v-if="auth" :class="{ 'active-tab': activetab == 'raceplan' }" class="tab-div">
        <router-link to="/raceplanner" class="sidebar-link"><h3 v-if="auth" @click="setActiveTab('raceplan')">Race Planner</h3></router-link>
      </div>
      <div v-if="auth" :class="{ 'active-tab': activetab == 'buddyfinder' }" class="tab-div">
        <router-link :to="{ name: 'Buddy Finder' }" class="sidebar-link"><h3 v-if="auth" @click="setActiveTab('buddyfinder')">Run Buddy Finder</h3></router-link>
      </div>
      <div v-if="auth" class="tab-div">
        <router-link to="" class="sidebar-link"><h3 v-if="auth" @click="onLogout" class="sidebar-link" :class="{ 'active-tab': activetab == 'logout' }">Logout</h3></router-link>
      </div>
      <div v-if="!auth" :class="{ 'active-tab': activetab == 'signin' }" class="tab-div">
        <router-link to="/login" class="sidebar-link"><h3 v-if="!auth" @click="setActiveTab('signin')">Sign In</h3></router-link>
      </div>
      <div v-if="!auth && !($router.history.current.path =='/marathondynamics')" :class="{ 'active-tab': activetab == 'signup' }" class="tab-div">
        <router-link to="/register" class="sidebar-link"><h3 v-if="!auth" @click="setActiveTab('signup')">Sign Up</h3></router-link>
      </div>

      <!-- <p>{{ activetab }}</p> -->
    </div>
    <!-- {{ team }} -->
    <div v-if="team == 'MDI'">
      <img class="mt-4 ml-2" src="../../assets/img/marathondynamics/MDIlogo_notext_white.png" alt="" width="100" height="" style="">
    </div>
    <div v-if="team == 'Ryerson'">
      <img class="mt-4 ml-2" src="../../assets/img/ryerson/main_logo.svg" alt="" width="100" height="" style="">
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        activetab: '',
        // team: '',
      }
    },
    created() {
      // this.team = this.$store.getters.team
    },
    computed: {
      auth () { // Lecture 363
        return this.$store.getters.isAuthenticated
      },
      // activetab () {
      //   return this.$store.getters.menuState
      // }
      team () {
        if (this.$store.getters.team) {
          return this.$store.getters.team
        }
        else {
          return ''
        }
      },
      isCoach () {
        return this.$store.getters.isCoach
      },
    },
    methods: {
      onLogout() {
        this.activetab = 'signin'
        this.$router.replace('/')
        this.$store.dispatch('logout')
      },
      setActiveTab(tab) {
        this.activetab = tab
        // this.$store.dispatch('setMenuState', { menuState: tab })
        // this.activetab = this.$store.getters.menuState
      },
    },
  }
</script>

<style scoped>
  /* .generic {
    background-color: var(--coredarkcolor);
  } */
  /* .MDI {
    background-color: var(--MDI);
  } */

  a {
    color: #fff;
  }
  a:hover {
    /* text-transform: none; */
    text-decoration: none;
  }

  .sidebar-link h3 {
    color: #fff;
    text-transform: uppercase;
    font-size: 18px;
    /* font-weight: 900; */
    /* font-family: 'Open Sans', sans-serif; */
    /* font-weight: 800; */
    /* font-weight: 700; */
  }

  .tab-div {
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 1px;
  }
  .tab-div:hover {
    cursor: pointer;
  }
  .active-tab {
    /* color: green; */
    background: #5e8dad;
    /* color: #183a52; */
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    /* padding-left: 10px; */
    /* padding-top: 4px; */

  }
  .router-link-exact-active {
    /* background: #fff;
    color: #183a52;
    padding-left: 10px;
    padding-top: 4px;
    padding-bottom: 8px; */
    /* font-size: 18px;
    font-weight: 700 */
  }
</style>



// WEBPACK FOOTER //
// src/components/myrundash/Sidebar.vue